import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const COVERAGE_STATUSES = {
    idle: 'idle',
    loading: 'loading',
    succeeded: 'succeeded',
    failed: 'failed'
};

const initialState = {
    assetOwners: {},
    myCoverage: {},
    myCoverageStatus: COVERAGE_STATUSES.idle,
    croppedServiceArea: null
};

export const fetchMyCoverageOnce = createAsyncThunk(
    'coverageAssetOwners/fetchMyCoverageOnce',
    async () => {
        const { AssetOwnerService } = await import('client/services');
        return await AssetOwnerService.getMyCoverageArea();
    },
    {
        condition: (_, { getState }) => {
            const status = getState()?.coverageAssetOwners?.myCoverageStatus;
            return status === COVERAGE_STATUSES.idle;
        }
    }
);

const coverageAssetOwnersSlice = createSlice({
    name: 'coverageAssetOwners',
    initialState,
    reducers: {
        setCoverageAssetOwners: (state, action) => {
            state.assetOwners = action.payload;
        },
        setMyCoverage: (state, action) => {
            state.myCoverage = action.payload;
            state.myCoverageStatus = COVERAGE_STATUSES.succeeded;
        },
        setCroppedServiceArea: (state, action) => {
            state.croppedServiceArea = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMyCoverageOnce.pending, (state) => {
                state.myCoverageStatus = COVERAGE_STATUSES.loading;
            })
            .addCase(fetchMyCoverageOnce.fulfilled, (state, action) => {
                if (action.payload) {
                    state.myCoverage = action.payload;
                }
                state.myCoverageStatus = COVERAGE_STATUSES.succeeded;
            })
            .addCase(fetchMyCoverageOnce.rejected, (state) => {
                state.myCoverageStatus = COVERAGE_STATUSES.failed;
            });
    }
});

export const selectMyCoverage = (state) => state?.coverageAssetOwners?.myCoverage;
export const selectCroppedServiceArea = (state) => state?.coverageAssetOwners?.croppedServiceArea;

export const {
    setCoverageAssetOwners,
    setMyCoverage,
    setCroppedServiceArea
} = coverageAssetOwnersSlice.actions;
export default coverageAssetOwnersSlice.reducer;
